import { TextField } from "@mui/material";
import { GridFilterOperator } from "@mui/x-data-grid-pro";
import createFilter from "./helpers/CreateFilterHelper";

const CustomFilterOperatorInputNumber = (props: any) => {
    const { item, applyValue } = props;
    const handleChange = (event: any) => {
      applyValue({ ...item, value: event.target.value});
    };
    return <TextField placeholder={props.label}  sx={{mt:'16px'}} variant="filled" size="small" type="number" value={item.value || ''} onChange={handleChange} />;
  };

  const PercentageFilterOperator: GridFilterOperator[] = [
    {
        label: 'Equals',
        value: 'eq',
        getApplyFilterFn: createFilter((cellValue, filterValue) => {
            if (cellValue === undefined || filterValue === undefined) return false;
            const cellNum = Number(cellValue.toString().replace('%', ''));
            const filterNum = Number(filterValue.toString().replace('%', ''));
            return cellNum === filterNum;
        }),
        InputComponentProps: { type: 'text' },
        InputComponent: CustomFilterOperatorInputNumber,
    },
    {
        label: 'Less Than',
        value: 'lt',
        getApplyFilterFn: createFilter((cellValue, filterValue) => {
            if (cellValue === undefined || filterValue === undefined) return false;
            const cellNum = Number(cellValue.toString().replace('%', ''));
            const filterNum = Number(filterValue.toString().replace('%', ''));
            return cellNum < filterNum;
        }),
        InputComponentProps: { type: 'text' },
        InputComponent: CustomFilterOperatorInputNumber,
    },
    {
        label: 'Greater Than',
        value: 'gt',
        getApplyFilterFn: createFilter((cellValue, filterValue) => {
            if (cellValue === undefined || filterValue === undefined) return false;
            const cellNum = Number(cellValue.toString().replace('%', ''));
            const filterNum = Number(filterValue.toString().replace('%', ''));
            return cellNum > filterNum;
        }),
        InputComponentProps: { type: 'text' },
        InputComponent: CustomFilterOperatorInputNumber,
    },
    {
        label: 'Not Equals',
        value: 'neq',
        getApplyFilterFn: createFilter((cellValue, filterValue) => {
            if (cellValue === undefined || filterValue === undefined) return false;
            const cellNum = Number(cellValue.toString().replace('%', ''));
            const filterNum = Number(filterValue.toString().replace('%', ''));
            return cellNum !== filterNum;
        }),
        InputComponentProps: { type: 'text' },
        InputComponent: CustomFilterOperatorInputNumber,
    },
];

export default PercentageFilterOperator;